import Text from "Components/shared/text";
import React, { useEffect, useState } from "react";
import { Storage } from "utils/clientStorage";
import styles from "./container.module.css";

export const ToDos = ({ profile, bvn, pin }) => {

  return (
    <Text tag="div" className={styles.todoList}>
      <Text tag="div">
        <Text tag="div">
          <input type="radio" checked={profile} />
        </Text>
        <Text tag="div">
          <Text className={styles.todoHead}>Complete your profile</Text>
          <Text className={styles.todoBody}>
            Complete your profile kyc to be able to access all features
          </Text>
        </Text>
      </Text>
      <Text tag="div">
        <Text tag="div">
          <input type="radio" checked={bvn} />
        </Text>
        <Text tag="div">
          <Text>Add your BVN</Text>
          <Text className={styles.todoBody}>
            Add your bank verification number{" "}
          </Text>
        </Text>
      </Text>
      <Text tag="div">
        <Text tag="div">
          <input type="radio" checked={pin} />
        </Text>
        <Text tag="div">
          <Text>Set your transaction Pin</Text>
          <Text className={styles.todoBody}>
            your transaction pin help you secure your account.{" "}
          </Text>
        </Text>
      </Text>
      {/* <Text tag="div">
        <Text tag="div">
          <input type="radio" checked={profile}/>
        </Text>
        <Text tag="div">
          <Text>Deposit Money into your wallet</Text>
          <Text className={styles.todoBody}>
            do a deposit into your wallet{" "}
          </Text>
        </Text>
      </Text> */}
    </Text>
  );
};
